import { useCallback, useEffect } from 'react';
import { setCreateAlert } from 'redux/reducers/meteorologyFieldsGroupLocationFeedbackReducer';
import { store } from 'redux/store';
import { ResponseError } from 'services/api/base';
import { useSaveFieldsGroupMutation } from 'services/api/Meteorology/Fields/TrackingForecast/Register';

export default function useSaveGroup() {
  const [trigger, { data, isLoading, error }] = useSaveFieldsGroupMutation();
  const saveGroup = useCallback((name: string, description: string) => {
    trigger({ name, description });
  }, [trigger]);

  useEffect(() => {
    if (error) {
      const responseError = error as ResponseError;
      store.dispatch(setCreateAlert({
        title: responseError.data || 'Erro',
        message: responseError.description || 'Ocorreu um erro ao salvar o grupo.',
        variant: 'danger',
      }));
    }
  }, [error]);

  useEffect(() => {
    if (data) {
      store.dispatch(setCreateAlert({
        title: data.title || 'Sucesso',
        message: data.message || 'Grupo criado com sucesso.',
        variant: 'success',
      }));
    }
  }, [data]);

  return {
    saveGroup,
    isSavingGroup: isLoading,
  };
}
